import { Card, Flex, Typography, Select } from "antd";
import React from "react";
import "./Selector.scss";

const Selector = ({
  options = [],
  value = "Select Trust",
  setValue = () => {},
}) => {
  const { Text } = Typography;

  return (
    <Card className="selector_main_div">
      <Flex className="selectorWrapperMain" vertical gap="small">
        <Text className="selector_label">Trust</Text>
        <Flex className="selector_box">
          <Select
            defaultValue="Select Trust"
            popupClassName="custom-trust-dropdown"
            style={{}}
            placeholder="Select Trust"
            options={options}
            onChange={(val) => setValue(val)}
            value={value}
          />
        </Flex>
      </Flex>
    </Card>
  );
};

export default Selector;
